import type { PropsWithChildren } from 'react'
import cn from 'classnames'
import styles from './CheckoutHeading.module.css'

interface CheckoutHeadingProps extends PropsWithChildren {
  className?: string
}

export function CheckoutHeading({ children, className }: CheckoutHeadingProps) {
  return (
    <div className={cn(styles.checkoutHeading, className)}>
      {children}
    </div>
  )
}

export function CheckoutHeadingTitle({ children, className }: CheckoutHeadingProps) {
  return (
    <h1 className={cn(styles.title, className)}>
      {children}
    </h1>
  )
}

export function CheckoutHeadingDescription({ children, className }: CheckoutHeadingProps) {
  return (
    <p className={cn(styles.description, className)}>
      {children}
    </p>
  )
}
